import { render } from "./StatusBadge.vue?vue&type=template&id=c54397c0"
import script from "./StatusBadge.vue?vue&type=script&lang=ts"
export * from "./StatusBadge.vue?vue&type=script&lang=ts"
script.render = render

export default script